import { useState } from 'react'
import { USER_PROFILE } from '@/config/userProfile'
import { useAppearanceTheme } from '@/theme/AppThemeProvider'

export function useGeneralSettingsState() {
  const { mode: theme, setMode: setTheme } = useAppearanceTheme()
  const [firstName, setFirstName] = useState(USER_PROFILE.firstName)
  const [lastName, setLastName] = useState(USER_PROFILE.lastName)
  const email = USER_PROFILE.email

  return { theme, setTheme, firstName, setFirstName, lastName, setLastName, email }
}
